import React, { useState } from "react";
import {
  IconButton,
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  ChevronLeftRounded,
  ChevronRightRounded,
  CloseRounded,
  DeleteOutline,
} from "@mui/icons-material";
import styles from "../../styles";
import { isEmpty } from "lodash";
import { getImageSrc } from "../../../../utils/CommonFunction";
import { ReactComponent as RightArrowIcon } from "../../../../assets/svg/RightArrowIcon.svg";
import AddIcon from "@mui/icons-material/Add";
import { useParams } from "react-router-dom";
import { postFormData, getApiData } from "../../../../utils/APIHelper";
import { Setting } from "../../../../utils/Setting";
import { toast } from "react-toastify";

function VariantCarousel({
  details,
  getDetailsApiCall,
  setSelectedBudget,
  selectedBudget,
}) {
  const { id } = useParams();
  const [startIndex, setStartIndex] = useState(0);
  // const [selectedBudget, setSelectedBudget] = useState(null);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [hovered, setHovered] = useState(false);

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) => Math.min(prev + 1, details?.variants?.length - 2));
  };

  const handleOpenModal = (item) => {
    setSelectedBudget(item);
  };

  const handleCloseModal = () => {
    setSelectedBudget(null);
  };

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file_1", file);
      formData.append("type", "boq_variant");
      formData.append("tags", "");
      formData.append("assign_id", selectedBudget?.id);

      try {
        const response = await postFormData(
          Setting.endpoints.packageFiles,
          formData
        );
        if (response.success) {
          toast.success("File uploaded successfully");
          await getDetailsApiCall(id);
        } else {
          toast.error("File upload failed");
        }
      } catch (error) {
        toast.error("An error occurred during file upload");
      }
    }
  };

  const handleDeleteImage = async () => {
    setButtonLoader(true);
    try {
      const imageId = selectedBudget?.image?.id;
      if (!imageId) {
        toast.error("No image to delete.");
        return;
      }

      const response = await getApiData(
        `api/project/delete-files/${imageId}`,
        "POST",
        {},
        { "Content-Type": "application/json" },
        false
      );

      if (response.success) {
        toast.success(response.message);
        await getDetailsApiCall(id);
      }
    } catch (error) {
      toast.error(error.toString());
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      {details?.variants?.length > 0 && (
        <>
          <div
            style={{
              ...styles.rowFlex,
              justifyContent: "space-between",
              marginRight: "2.5vw",
            }}
          >
            <div style={styles.section_heading}>Variants</div>
            {details?.variants?.length > 2 && (
              <div>
                <IconButton onClick={handlePrev} disabled={startIndex === 0}>
                  <ChevronLeftRounded />
                </IconButton>
                <IconButton
                  onClick={handleNext}
                  disabled={startIndex >= details?.variants?.length - 3}
                >
                  <ChevronRightRounded />
                </IconButton>
              </div>
            )}
          </div>

          <div
            style={{
              display: "flex",
              overflowX: "auto",
              gap: "20px",
              paddingBottom: "10px",
              scrollbarWidth: "none",
              scrollbarColor: "#D7D8D9 transparent",
              overflowX: "hidden",
            }}
          >
            {details?.variants
              ?.slice(startIndex, startIndex + 3)
              .map((item) => (
                <Grid
                  item
                  key={item.id}
                  onClick={() => handleOpenModal(item)}
                  style={{
                    flex: "0 0 45%",
                    borderRadius: "12px",
                    border: "1px solid #D7D8D9",
                    minWidth: "280px",
                    maxWidth: "380px",
                    cursor: "pointer",
                  }}
                >
                  <div>
                    <img
                      src={getImageSrc(item?.image?.path)}
                      alt={`Image ${item.id}`}
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                        borderTopRightRadius: "8px",
                        borderTopLeftRadius: "8px",
                      }}
                    />
                  </div>
                  <div style={{ ...styles.columnFlex, padding: "2vh 1vw" }}>
                    <div
                      style={{
                        ...styles.rowFlex,
                        justifyContent: "space-between",
                      }}
                    >
                      <h3 style={styles.budget_item_heading}>{item?.name}</h3>
                      <RightArrowIcon />
                    </div>

                    <p style={styles.budget_item_text}>{item?.description}</p>
                  </div>
                </Grid>
              ))}
          </div>

          <Dialog
            open={!!selectedBudget}
            onClose={handleCloseModal}
            maxWidth="sm"
            fullWidth
            sx={{
              "& .MuiPaper-root": {
                borderRadius: "12px",
              },
            }}
          >
            {selectedBudget && (
              <>
                <DialogTitle
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0",
                    position: "relative",
                  }}
                >
                  {/* <img
                    src={getImageSrc(selectedBudget?.image?.path)}
                    alt="Budget Detail"
                    style={{
                      width: "100%",
                      height: "250px",
                      objectFit: "cover",
                    }}
                  />
                  <IconButton
                    onClick={handleCloseModal}
                    style={{ position: "absolute", top: 5, right: 5 }}
                  >
                    <CloseRounded />
                  </IconButton> */}
                  {console.log("selectedBudget", selectedBudget)}
                  {!isEmpty(selectedBudget?.image) ? (
                    <div
                      style={{ position: "relative", width: "100%" }}
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                    >
                      <img
                        src={getImageSrc(selectedBudget?.image?.path)}
                        alt="Variant Image"
                        style={{
                          width: "100%",
                          height: "250px",
                          objectFit: "cover",
                          border: "none",
                          borderRadius: "8px",
                          borderBottomLeftRadius: 0,
                          borderBottomRightRadius: 0,
                          boxShadow: "none",
                        }}
                      />
                      {hovered && (
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            background: "rgba(0, 0, 0, 0.6)",
                            padding: "10px",
                            borderRadius: "50%",
                          }}
                        >
                          <IconButton
                            onClick={handleDeleteImage}
                            style={{
                              color: "white",
                              backgroundColor: "red",
                              borderRadius: "50%",
                            }}
                          >
                            <DeleteOutline style={{ fontSize: "18px" }} />
                          </IconButton>
                        </div>
                      )}
                    </div>
                  ) : (
                    <IconButton
                      component="label"
                      style={{
                        width: "100%",
                        height: "250px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "8px",
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        border: "1px dashed #ccc",
                        margin: "0",
                        cursor: "pointer",
                        background: "#fafafa",
                      }}
                    >
                      <AddIcon fontSize="small" />
                      <input
                        type="file"
                        hidden
                        onChange={(e) => handleImageChange(e)}
                        accept="image/*"
                      />
                    </IconButton>
                  )}
                  <IconButton
                    onClick={handleCloseModal}
                    style={{ position: "absolute", top: 5, right: 5 }}
                  >
                    <CloseRounded />
                  </IconButton>
                </DialogTitle>
                <DialogContent
                  style={{
                    ...styles.columnFlex,
                    ...styles.container,
                    gap: "25px",
                    padding: "5vh 2vw",
                  }}
                >
                  <div style={{ ...styles.columnFlex }}>
                    <h2 style={styles.modal_heading}>{selectedBudget?.name}</h2>
                    <p style={styles.modal_desc}>
                      {selectedBudget?.description}
                    </p>
                  </div>
                </DialogContent>
              </>
            )}
          </Dialog>
        </>
      )}
    </>
  );
}

export default VariantCarousel;
